import React from "react";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { DealerLocator } from "@/components/DealerLocator";

export default function Rivenditori() {
  return (
    <>
      <Seo title="Rivenditori SENIORCAR — Trova il centro più vicino"
        description="Trova il centro SENIORCAR più vicino a te per assistenza dedicata e ordine online. Rete di rivenditori in tutta Italia."
        keywords="rivenditori seniorcar, centri mobilità senior" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Rivenditori" }]} /></div>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Trova il centro SENIORCAR più vicino</h1>
        <p className="mt-4 text-lg sm:text-xl text-slate-600 max-w-2xl">Cerca per città, provincia o CAP e ordina online con il supporto del centro più vicino a te.</p>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10"><DealerLocator /></section>
    </>
  );
}
